import React from 'react';
import { motion } from 'framer-motion';
import { Heart, ShieldAlert } from 'lucide-react';
const forWho = ["Madres latinas en USA que se sienten 'agotadas y abotagadas' constantemente.", 'Mujeres que notan que su vientre se inflama drásticamente después de comer.', 'Mamás que no tienen tiempo para ir al gimnasio 2 horas pero necesitan resultados rápidos.', 'Aquellas que sienten que el estrés de la vida diaria está afectando su salud física.'];
const notForWho = ["Personas que buscan una 'pastilla mágica' milagrosa sin cambiar un solo hábito.", 'Quienes padecen insuficiencia renal crónica o condiciones médicas graves (deben consultar a su médico).', 'Personas que no están dispuestas a dedicar 5 minutos al día a su propio bienestar.'];
export function AudienceSection() {
  return <section className="py-20 px-4 bg-sage/30" data-id="element-2">
      <div className="max-w-5xl mx-auto" data-id="element-3">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-4">
          {/* WHO THIS IS FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-primary" data-id="element-5">
            <div className="flex items-center gap-3 mb-6" data-id="element-6">
              <Heart className="w-8 h-8 text-primary" data-id="element-7" />
              <h3 className="font-heading text-2xl text-ink" data-id="element-8">
                Esto ES para ti si:
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-9">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-10">
                  <span className="text-primary font-bold mt-0.5" data-id="element-11">✓</span>
                  <span className="text-ink/80" data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* WHO THIS IS NOT FOR */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="bg-white p-8 rounded-3xl shadow-sm border-t-4 border-ink/20" data-id="element-13">
            <div className="flex items-center gap-3 mb-6" data-id="element-14">
              <ShieldAlert className="w-8 h-8 text-ink/40" data-id="element-15" />
              <h3 className="font-heading text-2xl text-ink/60" data-id="element-16">
                Esto NO es para ti si:
              </h3>
            </div>
            <ul className="space-y-4" data-id="element-17">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-3 opacity-70" data-id="element-18">
                  <span className="text-ink/40 font-bold mt-0.5" data-id="element-19">✕</span>
                  <span className="text-ink/80" data-id="element-20">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}